module.exports = __webpack_public_path__ + "static/media/union-pay-logo.296d56c5.png";